import { consoleInfo } from '@gravityforms/utils';

/**
 * @function bindEvents
 * @description Bind global event listeners here,
 *
 */

const bindEvents = () => {};

const init = () => {
	bindEvents();

	consoleInfo( 'Gravity Forms Conversational Forms Common: Initialized all javascript that targeted document ready.' );
};

export default init;
